// export const fetchAvailableBuilds = async () => {
//   const response = await fetch(`${process.env.REACT_APP_PYTHON_API_URL}/api/available-builds`);
//   return response.json();
// };
import axios from 'axios';
import Env from '../../../runtimeEnv';
import { isDemoMode } from '../../../demo/demoMode';

const demoBuild = {
  therapist_id: 'demo-therapist',
  name: 'Demo Therapist Space',
  description: 'Local demo space for testing instant session links.',
  url: 'http://localhost:3000/demo-space',
};

export const generateSingleLink = async (formData) => {
  if (isDemoMode) {
    const expiresAt = new Date(
      Date.now() + (Number(formData.expiration_hours) || 24) * 60 * 60 * 1000
    );

    return {
      success: true,
      url: `http://localhost:3000/demo-session?token=local-${Date.now()}`,
      expires_at: expiresAt.toISOString(),
      build_info: demoBuild,
    };
  }

  const response = await fetch(`${Env.REACT_APP_PYTHON_API_URL}/api/generate-single-link`, { credentials: "include",
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
  return response.json();
};

// ✅ Fetch therapist builds (with presigned URLs)
export const fetchTherapistBuilds = async () => {
  if (isDemoMode) {
    return { success: true, therapists: [demoBuild] };
  }

  try {
    const response = await axios.get(`${Env.REACT_APP_PYTHON_API_URL}/api/therapist-builds`, { withCredentials: true });
    return response.data; // { success: true, therapists: [...] }
  } catch (error) {
    console.error("Error fetching therapist builds:");
    return { success: false, therapists: [] };
  }
};
